<quill-editor
  [(ngModel)]="value"
  (ngModelChange)="onChange($event)"
  [placeholder]="placeholder"
  [required]="required"
  [readOnly]="readonly"
  [disabled]="disabled || readonly"
  [modules]="quillConfig"
  [sanitize]="true"
  [styles]="{ height: height + 'px' }"
  (onBlur)="onBlur()"
  (onSelectionChanged)="onSelectionChanged($event)"
/>
